<ion-header>
  <ion-toolbar>
    <ion-title>{{ 'AUTH.REGISTER' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button color="toolbar-button" (click)="close.emit(false)">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content color="light">
  @if (codeSent()) {
    <div class="ion-padding">
      <header class="my-8">
        <h1>{{ 'AUTH.MERGE_ACCOUNTS.ENTER_VERIFICATION_CODE' | translate }}</h1>

        <p class="small">
          {{ 'AUTH.MERGE_ACCOUNTS.ENTER_VERIFICATION_CODE_SUBTITLE' | translate }}:
          <strong>{{ obfuscatedEmail() }}</strong>
        </p>
      </header>

      <ion-input-otp [formControl]="codeControl" class="max-w-full" length="6" shape="soft"></ion-input-otp>
    </div>
  } @else {
    <form [formGroup]="form" (submit)="register()">
      <ion-list [inset]="true">
        <ion-item>
          <ion-input
            type="text"
            name="firstName"
            formControlName="firstName"
            [label]="'AUTH.FIRST_NAME' | translate"
            labelPlacement="fixed"
            [errorText]="'ERROR.FIELD_REQUIRED' | translate"
            scAutofill
            autocomplete="given-name"
            autocapitalize="words"
            required></ion-input>
        </ion-item>
        <ion-item>
          <ion-input
            type="text"
            name="lastName"
            formControlName="lastName"
            [label]="'AUTH.LAST_NAME' | translate"
            labelPlacement="fixed"
            [errorText]="'ERROR.FIELD_REQUIRED' | translate"
            scAutofill
            autocomplete="family-name"
            autocapitalize="words"
            required></ion-input>
        </ion-item>
        <ion-item>
          <ion-input
            type="email"
            name="email"
            formControlName="email"
            [label]="'AUTH.EMAIL' | translate"
            labelPlacement="fixed"
            [errorText]="'AUTH.ENTER_VALID_EMAIL' | translate"
            scAutofill
            autocomplete="email"
            email
            required></ion-input>
        </ion-item>
      </ion-list>

      <div class="ion-padding mx-2">
        <ion-checkbox labelPlacement="end" formControlName="acceptTerms">
          <div class="ion-text-wrap">
            {{ 'AUTH.REGISTER_ACCEPT_TERMS_POLICY' | translate }}
            <ion-icon name="open-outline" (click)="openAgreements($event)"></ion-icon>
          </div>
        </ion-checkbox>
      </div>

      <div class="ion-padding">
        <ion-button expand="block" type="submit" [disabled]="form.invalid || saving()">
          {{ 'AUTH.REGISTER' | translate }}
        </ion-button>
      </div>
    </form>
  }
</ion-content>
